import React from 'react';
import { compose, contains } from 'ramda';

import styleFile from './Tooltip.js';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import * as ReactDOM from 'react-dom';
import Image from '@synergycms_core/components/generic/Image';

const Tooltip = class Tooltip extends React.Component {
  constructor(props) {
    super(props);
    this.parentRef = props.config.parentRef;
    this.pointerHeight = 0;
    this.pointerWidth = 0;
    this.state = {
      tooltipReference: null,
      pointerReference: null,
      closeButtonReference: null,
      pointerDOMElem: null,
      event: false,
      isMobile: this.props.theme.uaDeviceType !== 'DESK'
    };
    this.toggleTooltip = this.props.config.toggleTooltip;
  }

  static displayName = 'Tooltip';
  shouldComponentUpdate = () => {
    this.positionToolTip(this.state.tooltipReference);
    this.positionToolTip(this.state.pointerReference);
    // FIXME BULLSHIT
    return true;
  };

  /*posX pot tenir 3 diferents valors:
         bottom  (mostrarse verticalment a la meitat de l'altura del botó que ha disparat el tooltip )
         top     (mostrarse verticalment a sobre el botó)
         middle  (mostrarse verticalment a sota el botó)
         TODO: MAJOR REFACTOR*/
  setLeftPosition = ref => {
    const rightLimit = this.props.config.rightLimit || 15;
    const leftLimit = this.props.config.leftLimit || 10;

    const { width } = this.props.theme;
    const parentRef = this.parentRef.getBoundingClientRect();

    //Aquest valor s'utilitza unicament per diferenciar per la fletxa del tooltip i el tooltip en si
    const isTooltip = this.state.tooltipReference === ref;

    //mesures fins el left al left amb scroll i sense
    const scrolledDistanceLeft = Math.abs(document.body.getBoundingClientRect().left);
    const parentTotalDistanceLeft = parentRef.left + scrolledDistanceLeft;

    //height de cada element
    //parent = element trigger per mostrar el tooltip
    //floatting = element passat per parametre pot intercalar entra la punta o el tooltip
    // tooltip = element tooltip
    const parentWidth = this.parentRef.offsetWidth;
    const floatingElemWidth = ref.offsetWidth;
    if (!isTooltip) {
      this.pointerWidth = floatingElemWidth / 2;
    }
    const tooltipWidth = this.state.tooltipReference.offsetWidth;

    //mesures del width de la pantalla amb el limit preestablert maxim
    const validRightScreenWidth = width - rightLimit;
    const validLeftScreenWidth = parentRef.left + parentWidth / 2 + scrolledDistanceLeft - leftLimit;

    let leftDistanceResult = parentTotalDistanceLeft;

    //posicionat d'acord als parametres passats a la config
    switch (this.props.config.posX) {
      case 'right':
        if (!isTooltip) ref.style.transform = 'rotate(45deg)';
        leftDistanceResult += isTooltip ? parentWidth + this.pointerWidth : parentWidth;
        break;
      case 'left':
        if (!isTooltip) ref.style.transform = 'rotate(225deg)';
        leftDistanceResult += isTooltip ? -floatingElemWidth - this.pointerWidth : -floatingElemWidth;
        break;
      case 'middle':
      default:
        leftDistanceResult += (parentWidth - floatingElemWidth) / 2;
        break;
    }

    //posicionat forçat en relacio de si entra o no en l'espai restant
    if (contains(this.props.config.posX, ['left', 'right'])) {
      //si el tooltip no entra al left forcem posicionat al right
      const totalRightDistance = parentTotalDistanceLeft + parentWidth + this.pointerWidth + tooltipWidth;
      const totalleftDistance = parentTotalDistanceLeft - tooltipWidth - this.pointerWidth;
      if (totalleftDistance < scrolledDistanceLeft + leftLimit) {
        leftDistanceResult = parentTotalDistanceLeft + (isTooltip ? parentWidth + this.pointerWidth : parentWidth);
        if (!isTooltip) ref.style.transform = 'rotate(45deg)';
      } else if (
        //si el tooltip no entra al right forcem posicionat al left
        totalRightDistance >
        scrolledDistanceLeft + validRightScreenWidth
      ) {
        leftDistanceResult =
          parentTotalDistanceLeft + (isTooltip ? -floatingElemWidth - this.pointerWidth : -floatingElemWidth);

        if (!isTooltip) ref.style.transform = 'rotate(225deg)';
      }
    } else {
      //en el cas de ser middle, s'ajusta
      //si el tooltip es surt per el left l'ajustem
      if (floatingElemWidth / 2 > validLeftScreenWidth) {
        leftDistanceResult = leftLimit + (!isTooltip ? 5 : 0);
        //si el tooltip es surt per el right lajustem
      } else if (leftDistanceResult + floatingElemWidth > validRightScreenWidth) {
        leftDistanceResult = validRightScreenWidth - floatingElemWidth - (!isTooltip ? 5 : 0);
      }
    }

    return Math.round(leftDistanceResult) + 'px';
  };

  /*posY pot tenir 3 diferents valors:
       bottom  (mostrarse horitzontalment a la meitat de l'amplada del botó que ha disparat el tooltip )
       top     (mostrarse horitzontalment a sobre el botó)
       middle  (mostrarse horitzontalment a sota el botó)
       TODO: MAJOR REFACTOR*/

  setTopPosition = ref => {
    const bottomLimit = this.props.config.bottomLimit || 10;
    const topLimit = this.props.config.topLimit || 80;

    const { height } = this.props.theme;
    const parentRef = this.parentRef.getBoundingClientRect();
    //Aquest valor s'utilitza unicament per diferenciar per la fletxa del tooltip i el tooltip en si
    const isTooltip = this.state.tooltipReference === ref;

    //mesures fins el top al top amb scroll i sense
    const scrolledDistanceTop = Math.abs(document.body.getBoundingClientRect().top);
    const parentTotalDistanceTop = parentRef.top + scrolledDistanceTop;
    //height de cada element
    //parent = element trigger per mostrar el tooltip
    //floatting = element passat per parametre pot intercalar entra la punta o el tooltip
    // tooltip = element tooltip
    const parentHeight = this.parentRef.offsetHeight;
    const floatingElemHeight = ref.offsetHeight;
    if (!isTooltip) {
      this.pointerHeight = floatingElemHeight / 2;
    }
    const tooltipHeight = this.state.tooltipReference.offsetHeight;

    let topDistanceResult = parentTotalDistanceTop;

    //mesures del heigh i width de la pantalla amb el limit preestablert maxim
    const validBottomScreenHeight = height - bottomLimit;
    const validTopScreenHeight = parentRef.top + parentHeight / 2 + scrolledDistanceTop - topLimit;

    //posicionat d'acord als parametres passats a la config
    switch (this.props.config.posY) {
      case 'bottom':
        topDistanceResult += isTooltip ? parentHeight + this.pointerHeight : parentHeight;
        if (!isTooltip) ref.style.transform = 'rotate(135deg)';
        break;
      case 'top':
        topDistanceResult += isTooltip ? -floatingElemHeight - this.pointerHeight : -floatingElemHeight;
        if (!isTooltip) ref.style.transform = 'rotate(315deg)';
        break;
      case 'middle':
      default:
        topDistanceResult += (parentHeight - floatingElemHeight) / 2;
        break;
    }

    //posicionat forçat en relacio de si entra o no en l'espai restant
    if (contains(this.props.config.posY, ['top', 'bottom'])) {
      const totalBottomDistance = parentTotalDistanceTop + parentHeight + this.pointerHeight + tooltipHeight;
      const totaltopDistance = parentTotalDistanceTop - tooltipHeight - this.pointerHeight;
      //si el tooltip no entra al top forcem posicionat al bottom
      if (totaltopDistance < scrolledDistanceTop + topLimit) {
        topDistanceResult = parentTotalDistanceTop + (isTooltip ? parentHeight + this.pointerHeight : parentHeight);

        if (!isTooltip) ref.style.transform = 'rotate(135deg)';
      } else if (
        //si el tooltip no entra al bottom forcem posicionat al top
        totalBottomDistance >
        scrolledDistanceTop + validBottomScreenHeight
      ) {
        topDistanceResult =
          parentTotalDistanceTop + (isTooltip ? -floatingElemHeight - this.pointerHeight : -floatingElemHeight);

        if (!isTooltip) ref.style.transform = 'rotate(315deg)';
      }
    } else {
      //en el cas de ser middle, s'ajusta
      //si el tooltip es surt per el top l'ajustem
      if (floatingElemHeight / 2 > validTopScreenHeight) {
        topDistanceResult = topLimit + (!isTooltip ? 5 : 0);
        //si el tooltip es surt per el bottom lajustem
      } else if (topDistanceResult + floatingElemHeight > validBottomScreenHeight) {
        topDistanceResult = validBottomScreenHeight - floatingElemHeight - (!isTooltip ? 5 : 0);
      }
    }

    return Math.round(topDistanceResult) + 'px';
  };

  componentWillUnmount = () => {
    const typeEvent = this.state.isMobile ? 'click' : 'mouseleave';
    this.state.tooltipDOMElem.removeEventListener('mouseenter', this.toggleTooltip(true));
    this.state.tooltipDOMElem.removeEventListener(typeEvent, this.toggleTooltip(false));
    !this.props.config.avoidPointer &&
      this.state.pointerDOMElem.removeEventListener('mouseenter', this.toggleTooltip(true));
    !this.props.config.avoidPointer &&
      this.state.pointerDOMElem.removeEventListener(typeEvent, this.toggleTooltip(false));
    if (this.state.closeButtonDOMElement) {
      this.state.closeButtonDOMElement.removeEventListener(typeEvent, this.toggleTooltip(false));
    }
  };

  callbackBindRef = ref => {
    const DOMElem = ReactDOM.findDOMNode(ref);
    if (DOMElem) {
      const typeEvent = this.state.isMobile ? 'click' : 'mouseleave';
      !this.state.isMobile && DOMElem.addEventListener('mouseenter', this.toggleTooltip(true));
      if (this.state.isMobile) {
        !this.props.config.onlyCloseByButton && DOMElem.addEventListener(typeEvent, this.toggleTooltip(false));
      } else {
        DOMElem.addEventListener(typeEvent, this.toggleTooltip(false));
      }
    }
    this.setState(
      {
        tooltipReference: ref,
        tooltipDOMElem: DOMElem
      },
      () => this.positionToolTip(ref)
    );
  };

  callbackBindCloseButton = ref => {
    const DOMElem = ReactDOM.findDOMNode(ref);
    if (DOMElem) {
      const typeEvent = this.state.isMobile ? 'click' : 'mouseleave';
      DOMElem.addEventListener(typeEvent, this.toggleTooltip(false));
    }
    this.setState({
      closeButtonReference: ref,
      closeButtonDOMElement: DOMElem
    });
  };

  callbackBindPointer = ref => {
    const DOMElem = ReactDOM.findDOMNode(ref);
    if (DOMElem) {
      const typeEvent = this.state.isMobile ? 'click' : 'mouseleave';
      !this.state.isMobile && DOMElem.addEventListener('mouseenter', this.toggleTooltip(true));
      if (this.state.isMobile) {
        !this.props.config.onlyCloseByButton && DOMElem.addEventListener(typeEvent, this.toggleTooltip(false));
      } else {
        DOMElem.addEventListener(typeEvent, this.toggleTooltip(false));
      }
    }
    this.setState(
      {
        pointerReference: ref,
        pointerDOMElem: DOMElem
      },
      () => this.positionToolTip(ref)
    );
  };

  positionToolTip = ref => {
    if (ref) {
      ref.style.left = this.setLeftPosition(ref);
      ref.style.top = this.setTopPosition(ref);
    }
  };

  render() {
    const { children, theme, config } = this.props;
    const { classes } = theme.styles;
    return (
      <div>
        {!config.avoidPointer && <div className={config.pointerStyle} ref={this.callbackBindPointer} />}
        <div className={theme.computedInnerStyle} ref={this.callbackBindRef}>
          {children}
          {this.state.isMobile && (
            <Image ref={this.callbackBindCloseButton} innerStyle={[classes.closeButton]} unicodeContent={'e001'} />
          )}
        </div>
      </div>
    );
  }
};

export default compose(
  PropertyManager([
    'type',
    'alt',
    'parentRef',
    'posY',
    'setToggleChildren',
    'posX',
    'toggleTooltip',
    'bottomLimit',
    'avoidPointer',
    'pointerStyle',
    'onlyCloseByButton'
  ]),
  withThemeJSS({ styleFile })
)(Tooltip);
